import ButtonGroup from '@/global/components/ButtonGroup'
import { Button } from '@/global/components/ui/button'
import { cn } from '@/lib/utils'
import { useStore } from '@/store'
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react'
import { useEffect, useState } from 'react'
import { useEscopoContext } from './context'
import { um } from './escopo'

/**
 * Setas para percorrer os funcionários do escopo sem abrir o painel — o Espelho
 * do ponto é folheado funcionário a funcionário. Quando chega no fim das
 * páginas carregadas, puxa a próxima e segue no primeiro dela.
 *
 * Só faz sentido com a faceta de funcionário em seleção única.
 */
export function NavegarFuncionario({
    className,
    followStore = true,
}: {
    className?: string
    /** Segue o funcionarioId do store */
    followStore?: boolean
}) {
    const { valor, setFaceta, dados } = useEscopoContext()
    const [navegando, setNavegando] = useState(false)
    const funcionarioId = useStore(state => state.employeeId)

    const opcoes = dados.funcionarios.opcoes
    const atual = um(valor.funcionarios)
    const indice = opcoes.findIndex(opcao => opcao.id === atual)

    const isPrimeiro = indice <= 0
    const isUltimo =
        indice === -1 ||
        (indice === opcoes.length - 1 && !dados.funcionarios.temMais)

    useEffect(() => {
        if (!followStore) return
        if (funcionarioId > 0) setFaceta('funcionarios', funcionarioId)
    }, [funcionarioId, followStore])

    async function proximo() {
        if (indice > -1 && indice < opcoes.length - 1) {
            setFaceta('funcionarios', opcoes[indice + 1].id)
            return
        }

        if (!dados.funcionarios.carregarMais) return

        setNavegando(true)
        const novos = await dados.funcionarios.carregarMais()
        setNavegando(false)

        if (novos.length) setFaceta('funcionarios', novos[0].id)
    }

    function anterior() {
        if (indice > 0) setFaceta('funcionarios', opcoes[indice - 1].id)
    }

    return (
        <ButtonGroup className={className}>
            <Button
                type="button"
                variant="outline"
                aria-label="Funcionário anterior"
                title="Funcionário anterior"
                disabled={isPrimeiro || navegando}
                onClick={anterior}
                className="h-full"
            >
                <ChevronLeftIcon className="text-foreground" />
            </Button>
            <Button
                type="button"
                variant="outline"
                aria-label="Próximo funcionário"
                title="Próximo funcionário"
                disabled={isUltimo || navegando}
                onClick={proximo}
                className="h-full"
            >
                <ChevronRightIcon className="text-foreground" />
            </Button>
        </ButtonGroup>
    )
}
